import { useRef, useState } from "react";
import {
  ButtonDiv,
  ActivedButtonContainer,
  ActiveMenu,
  MenuNone,
  MenuText,
  MenuCheck,
  MenuUnmarked,
  MenuOption,
  FilterClient,
  FilterModalTitle,
  FilterModalInput,
  FilterModalButtons,
  FilterRenderControler,
  FilterActivesText,
  FilterActivesData,
  FilterActivesClose,
  FilterActives1,
  FilterActives2,
  FilterActives3,
} from "./styles";

import { useOutsideDrop } from "../../../hooks/useOutsideDrop";
import Button from "../../../components/general/Button/index";
import Filter from "../../../assets/icons/Filter";
import Check from "../../../assets/icons/Check";
import ArrowRightMTask from "../../../assets/TaskModalIcons/ArrowRightMTask";
import Close from "../../../assets/icons/Close";
import Input from "../../../components/general/Input";

const SearchPopper = ({
  isOpen,
  setOpen,
  type,
  setType,
  search,
  setSearch,
  popperType = "client",
}) =>
  isOpen ? (
    <FilterClient>
      <FilterModalTitle>
        {popperType === "client"
          ? "Filtrar por Cliente:"
          : "Filtrar por Projeto:"}
      </FilterModalTitle>
      <FilterModalInput>
        <Input
          placeholder={popperType === "client" ? "Cliente..." : "Projeto..."}
          value={search}
          setValue={(e) => {
            setSearch(e);
          }}
          height="2.15rem"
        />
      </FilterModalInput>
      <FilterModalButtons>
        <Button
          content={"Cancelar"}
          width={"4.85rem"}
          outline
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
            setSearch("");
          }}
        />
        <Button
          content={"Aplicar filtro"}
          width={"6.05rem"}
          onClick={() => {
            //Requisição

            if (popperType === "client") {
              setType({ ...type, client: search });
            } else {
              setType({ ...type, flowTitle: search });
            }

            setOpen(false);
          }}
        />
      </FilterModalButtons>
    </FilterClient>
  ) : null;

export function TaskOptions({
  params,
  open,
  setOpen,
  type,
  setType,
  clientSearch,
  flowSearch,
  setFlowSearch,
  setClientSearch,
}) {
  const containerRef = useRef(null);
  useOutsideDrop(containerRef, () => {
    setOpen(false);
    setFlowOpen(false);
    setClientOpen(false);
  });
  const [clientOpen, setClientOpen] = useState(false);
  const [flowOpen, setFlowOpen] = useState(false);

  return (
    <>
      {!open ? (
        <ButtonDiv>
          <Button
            Icon={() => <Filter />}
            onClick={(e) => {
              setOpen(!open);
              e.stopPropagation();
            }}
            content="Filtros"
          />
        </ButtonDiv>
      ) : (
        <ActivedButtonContainer ref={containerRef}>
          <Button
            colorText="#7e858f"
            Icon={() => <Filter />}
            onClick={() => {
              setOpen(!open);
            }}
            content="Filtros"
            greenBase
          />
          <ActiveMenu>
            <MenuNone
              onClick={() => {
                if (!(!type.alpha && !type.creation))
                  setType({ ...type, alpha: false, creation: false });
              }}
            >
              <MenuText>Nenhum</MenuText>
              <MenuCheck>
                {!type.alpha && !type.creation ? (
                  <Check height={"1rem"} />
                ) : (
                  <MenuUnmarked />
                )}
              </MenuCheck>
            </MenuNone>
            <MenuOption
              onClick={() => {
                if (!(type.alpha && !type.creation))
                  setType({ ...type, alpha: true, creation: false });
              }}
            >
              <MenuText>Ordem Alfabética</MenuText>
              <MenuCheck>
                {type.alpha ? <Check height={"1rem"} /> : <MenuUnmarked />}
              </MenuCheck>
            </MenuOption>
            <MenuOption
              onClick={() => {
                if (!(!type.alpha && type.creation))
                  setType({ ...type, alpha: false, creation: true });
              }}
            >
              <MenuText>Data de Início</MenuText>
              <MenuCheck>
                {type.creation ? <Check height={"1rem"} /> : <MenuUnmarked />}
              </MenuCheck>
            </MenuOption>
            <MenuOption
              className="filter-client"
              onClick={() => {
                setClientOpen(true);
                setFlowOpen(false);
              }}
            >
              <MenuText>Filtrar por Cliente</MenuText>
              <ArrowRightMTask />
            </MenuOption>
            <MenuOption
              className="filter-client"
              onClick={() => {
                setFlowOpen(true);
                setClientOpen(false);
              }}
            >
              <MenuText>Filtrar por Projeto</MenuText>
              <ArrowRightMTask />
            </MenuOption>
          </ActiveMenu>
          <SearchPopper
            isOpen={clientOpen}
            setOpen={setClientOpen}
            type={type}
            setType={setType}
            search={clientSearch}
            setSearch={setClientSearch}
            popperType="client"
          />
          <SearchPopper
            isOpen={flowOpen}
            setOpen={setFlowOpen}
            type={type}
            setType={setType}
            search={flowSearch}
            setSearch={setFlowSearch}
            popperType="flow"
          />
        </ActivedButtonContainer>
      )}
      <FilterRenderControler>
        {!(!type.creation && !type.alpha) ? ( //! none
          <FilterActives1 style={{ top: "-3.3rem" }}>
            <FilterActivesText>Ordenação: </FilterActivesText>
            <FilterActivesData>
              {type.creation
                ? "Data de Início"
                : type.alpha
                ? "Ordem Alfabética"
                : null}
            </FilterActivesData>
            <FilterActivesClose>
              <Close
                onClick={() => {
                  setType({ ...type, creation: false, alpha: false });
                }}
              />
            </FilterActivesClose>
          </FilterActives1>
        ) : null}
        {type.client !== "" ? (
          <FilterActives2 style={{ top: "-1.5rem" }} Filter1Open={type.client}>
            <FilterActivesText>Cliente: </FilterActivesText>
            <FilterActivesData>{type.client}</FilterActivesData>
            <FilterActivesClose>
              <Close
                onClick={() => {
                  setType({ ...type, client: "" });
                }}
              />
            </FilterActivesClose>
          </FilterActives2>
        ) : null}
        {type.label !== "" ? (
          <FilterActives2 style={{ top: "0.7rem" }} Filter1Open={type.label}>
            <FilterActivesText>Tarefa: </FilterActivesText>
            <FilterActivesData>{type.label}</FilterActivesData>
            <FilterActivesClose>
              <Close
                onClick={() => {
                  setType({ ...type, label: "" });
                }}
              />
            </FilterActivesClose>
          </FilterActives2>
        ) : null}
        {type.flowTitle !== "" ? (
          <FilterActives3 style={{ top: "2.9rem" }}>
            <FilterActivesText>Fluxo: </FilterActivesText>
            <FilterActivesData>{type.flowTitle}</FilterActivesData>
            <FilterActivesClose>
              <Close onClick={() => setType({ ...type, flowTitle: "" })} />
            </FilterActivesClose>
          </FilterActives3>
        ) : null}
        {params.get("taskId") ? (
          <FilterActives2 style={{ top: "4.7rem" }}>
            <FilterActivesText>{"Notificação"}</FilterActivesText>
            <FilterActivesClose>
              <Close
                width={"3rem"}
                onClick={() => {
                  setType({ ...type, taskId: "" });
                }}
              />
            </FilterActivesClose>
          </FilterActives2>
        ) : null}
        {params.get("userId") ? (
          <FilterActives2 style={{ top: "4.7rem" }}>
            <FilterActivesText>{"Usuario"}</FilterActivesText>
            <FilterActivesClose>
              <Close
                width={"3rem"}
                onClick={() => {
                  setType({ ...type, userId: "" });
                }}
              />
            </FilterActivesClose>
          </FilterActives2>
        ) : null}
      </FilterRenderControler>
    </>
  );
}
